export const colourCode = {
  yellow: '#ffc200',
  darkGrey: '#9c9c9c',
};
